<template>
  <div id="providerContactForm" class="col-12 bg-white rounded p-4">
    <validation-observer ref="providerContactForm" v-slot="{}" tag="form">
      <div class="row">
        <div class="col-12 mt-2">
          <icon-view
            class="mr-2 rounded-circle"
            :icon="model.id ? 'fas fa-edit' : 'fas fa-plus'"
            icon-background="white"
            icon-color="#2EB882"
            icon-size="14px"
            :title="title"
          />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="primaryContactInfoName"
            rules="required"
          >
            <custom-input
              v-model="model.name"
              :custom-error-msg="'El nombre es requerido.'"
              :error="errors[0]"
              label="Nombre:"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <custom-input
            v-model="model.initial"
            label="Inicial:"
            maxlength="1"
          />
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="primaryContactInfoPaternalLastName"
            rules="required"
          >
            <custom-input
              v-model="model.paternalLastName"
              :custom-error-msg="'El apellido paterno es requerido.'"
              :error="errors[0]"
              label="Apellido Paterno:"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <custom-input
            v-model="model.maternalLastName"
            label="Apellido Materno:"
          />
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="providerMunicipality"
            rules="required"
          >
            <label class="data-title mb-0">Municipio de Residencia:</label>
            <custom-drop-down
              v-model="municipalitySelected"
              custom-error-msg="El municipio es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="municipalities"
              placeholder="Seleccione"
              @input="onChangeMunicipality"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <custom-input v-model="model.department" label="Departamento:" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="position"
            :rules="model.isPrimaryContactFlag ? 'required' : ''"
          >
            <custom-input
              v-model="model.posicion"
              custom-error-msg="La posición es requerida."
              :error="errors[0]"
              label="Posición:"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors, failedRules }"
            name="primaryContactInfoEmail"
            rules="required|email"
          >
            <custom-input
              v-model="model.email"
              :custom-error-msg="
                failedRules['email']
                  ? 'El correo electrónico no es válido.'
                  : 'El correo electrónico es requerido.'
              "
              :error="errors[0]"
              label="Correo Electrónico:"
              type="email"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            ref="cellPhone"
            v-slot="{ errors }"
            name="cellPhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Celular:</label>
            <custom-input
              v-model="model.cellPhone"
              :custom-error-msg="'El teléfono celular es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <validation-provider
            ref="workPhone"
            v-slot="{ errors }"
            name="workPhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Trabajo:</label>
            <custom-input
              v-model="model.workPhone"
              :custom-error-msg="'El teléfono trabajo es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            ref="fax"
            v-slot="{ errors }"
            name="fax"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Fax:</label>
            <custom-input
              v-model="model.fax"
              :custom-error-msg="'El fax es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            ref="homePhone"
            v-slot="{ errors }"
            name="homePhone"
            :rules="!isSomePhoneFilledUp ? 'required' : 'phone'"
          >
            <label class="data-title mb-0">Hogar:</label>
            <custom-input
              v-model="model.homePhone"
              :custom-error-msg="'El teléfono del hogar es requerido.'"
              :error="errors[0]"
              :mask-type="'Phone'"
              @input="validateField"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <custom-input v-model="model.telephoneWorkExtNo" label="Ext:" />
        </div>
        <div class="col-8">
          <check-box
            v-model="model.isPrimaryContactFlag"
            class="mt-4 check-box__extended"
            text="Primario"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3 mr-3">
          <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
            <div class="bd-highlight ml-2">
              <action-button
                i="fas fa-save fa-lg"
                text="Guardar"
                variant="success"
                @click="submitForm()"
              />
            </div>
            <div class="mx-0 bd-highlight">
              <action-button
                id="modal-btn-cancelar"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="$emit('cancel')"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider } from 'vee-validate';
import CheckBox from 'CheckBox';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import IconView from 'icon-view';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomDropDown from 'custom-drop-down';

import {
  addProviderContact,
  editProviderContact,
} from '@/services/provider/provider.api';

export default {
  name: 'AddProviderContact',
  components: {
    ValidationProvider,
    CustomInput,
    CheckBox,
    ActionButton,
    IconView,
    CustomDropDown,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    municipalities: {
      type: Array,
      default: () => [],
    },
    locationId: {
      type: Number,
      default: () => 0,
    },
    companyId: {
      type: Number,
      default: () => 0,
    },
  },
  data: () => ({
    municipalitySelected: null,
    model: {
      id: null,
      locationId: null,
      isPrimaryContactFlag: null,
      name: null,
      initial: null,
      paternalLastName: null,
      maternalLastName: null,
      department: null,
      posicion: null,
      email: null,
      cellPhone: null,
      workPhone: null,
      telephoneWorkExtNo: null,
      fax: null,
      homePhone: null,
      municipalityId: null,
    },
  }),
  mounted() {
    const scrollDiv = document.getElementById('providerContactForm').offsetTop;
    window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
    this.model = {
      id: this.value?.id || 0,
      isPrimaryContactFlag: this.value?.isPrimaryContactFlag,
      name: this.value?.name,
      initial: this.value?.initial,
      paternalLastName: this.value?.lastName,
      maternalLastName: this.value?.secondSurname,
      department: this.value?.workDepartmentName,
      posicion: this.value?.workPositionTitle,
      email: this.value?.email,
      cellPhone: this.value?.telephoneMobileNo,
      workPhone: this.value?.telephoneWorkNo,
      telephoneWorkExtNo: this.value?.telephoneWorkExtNo,
      fax: this.value?.telephoneWorkFaxNo,
      homePhone: this.value?.telephoneHomeNo,
      municipalityId: this.value?.municipalityId,
    };
  },
  computed: {
    title() {
      return this.model.id ? 'Editar Contacto' : 'Añadir Contacto';
    },
    isSomePhoneFilledUp() {
      const cellPhone = Boolean(this.model.cellPhone);
      const workPhone = Boolean(this.model.workPhone);
      const fax = Boolean(this.model.fax);
      const homePhone = Boolean(this.model.homePhone);
      return cellPhone || workPhone || fax || homePhone;
    },
  },
  methods: {
    validateField() {
      if (!this.isSomePhoneFilledUp) {
        this.$refs['cellPhone'].reset();
        this.$refs['workPhone'].reset();
        this.$refs['fax'].reset();
        this.$refs['homePhone'].reset();
      }
    },
    onChangeMunicipality(item) {
      this.model.municipalityId = item?.id;
    },
    async submitForm() {
      const isFormValid = await this.$refs.providerContactForm.validate();
      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información de contacto solicitada.',
          'error'
        );
        return;
      }
      if (this.model.id) {
        await this.updateProviderContact();
      } else {
        await this.addProviderContact();
      }
    },

    async addProviderContact() {
      const payload = {
        locationId: this.locationId,
        isPrimaryContactFlag: this.model.isPrimaryContactFlag,
        name: this.model.name,
        initial: this.model.initial,
        lastName: this.model.paternalLastName,
        secondSurname: this.model.maternalLastName,
        workDepartmentName: this.model.department,
        workPositionTitle: this.model.posicion,
        email: this.model.email,
        telephoneMobileNo: this.model.cellPhone,
        telephoneWorkNo: this.model.workPhone,
        telephoneWorkExtNo: this.model.telephoneWorkExtNo,
        telephoneWorkFaxNo: this.model.fax,
        telephoneHomeNo: this.model.homePhone,
        municipalityId: this.model.municipalityId,
        companyId: this.companyId,
      };

      const { data } = await addProviderContact(this.company, payload).catch(
        (error) => {
          this.ShowToast(
            'Alerta',
            `${error?.response?.data?.message ?? error?.message}.`,
            'error'
          );
          return { data: false };
        }
      );

      if (data) {
        if (data.userCreated) {
          this.ShowToast(
            `Confirmación`,
            'El contacto ha sido añadido exitosamente. Se procedió con la creación de la cuenta de usuario al contacto por ser identificado como primario.',
            'success'
          );
        } else {
          this.ShowToast(
            `Confirmación`,
            'El contacto ha sido añadido exitosamente.',
            'success'
          );
        }
      }

      this.$emit('save', data);
    },
    async updateProviderContact() {
      const payload = {
        id: this.model.id,
        locationId: this.locationId,
        isPrimaryContactFlag: this.model.isPrimaryContactFlag,
        name: this.model.name,
        initial: this.model.initial,
        lastName: this.model.paternalLastName,
        secondSurname: this.model.maternalLastName,
        workDepartmentName: this.model.department,
        workPositionTitle: this.model.posicion,
        email: this.model.email,
        telephoneMobileNo: this.model.cellPhone,
        telephoneWorkNo: this.model.workPhone,
        telephoneWorkExtNo: this.model.telephoneWorkExtNo,
        telephoneWorkFaxNo: this.model.fax,
        telephoneHomeNo: this.model.homePhone,
        municipalityId: this.model.municipalityId,
      };

      const { data } = await editProviderContact(
        this.model.id,
        this.companyId,
        payload
      ).catch((error) => {
        this.ShowToast(
          'Alerta',
          `${error?.response?.data?.message ?? error?.message}.`,
          'error'
        );
        return { data: false };
      });

      if (data) {
        if (data.userCreated) {
          this.ShowToast(
            `Confirmación`,
            'El contacto sido actualizado exitosamente. Se procedió con la creación de la cuenta de usuario al contacto por ser identificado como primario.',
            'success'
          );
        } else {
          this.ShowToast(
            `Confirmación`,
            'El contacto sido actualizado exitosamente.',
            'success'
          );
        }
      }

      this.$emit('save', data);
    },
  },
  watch: {
    'model.municipalityId': function(value) {
      if (this.municipalitySelected) return;
      if (!value) {
        this.municipalitySelected = null;
        return;
      }

      this.municipalitySelected = this.municipalities.find(
        (y) => y.id === value
      );
    },
  },
};
</script>
